import React, { Component } from "react";
import DetailPatient from "../form/DetailPatient";
import ModalPelayanan from "./ModalPelayanan";
import moment from "moment";
import ReactToPrint from "react-to-print";
import apiService from "apiService";
import Autocomplete from "react-autocomplete";
import ALERT, { confirmedAlert, toast } from "view/component/Alert";
import BlobPrint from "view/component/BlobPrint";

// import ContextData from "./ContextData";
class PelayananPx extends Component {
  // static contextType = ContextData;
  constructor(props) {
    super(props);
    this.state = {
      modules: [],
      visible: false,
      disable: false,
      data: this.props.data,
      modalShow: false,
      shoe: false,
      dataTreatments: [],
      treatments: [
        {
          visit_id: this.props.data?.visit?.id,
          visit_inpatient_detail_id: "",
          treatment_id: "",
          log: "0",
          treatment: { name: "" },
        },
      ],
      total: [],
      payment_type_id: this.props.data?.visit?.payment_type_id ?? 1,
      payment_types: []
    };
    // this.changeDetilData = this.changeDetilData.bind(this);
    this.deleted = this.deleted.bind(this);

  }
  // componentDidMount() {
  //   this.fetchPaymentTypes();
  // }
  fetchPaymentTypes = async () => {
    const res = await apiService.get("management/payment_types/read");
    if (res) {
      if (res.status === "success.") {
        this.setState({
          payment_types: res.data,
        });
      }
    }
  };
  handleBeforeGetContent = () => {
    return new Promise((resolve, reject) => {
      this.setState({ show: true }, () => resolve());
    });
  };
  // componentDidMount(){

  // }

  // getTreatmentDetail=async()=>{
  //     let res = await apiService.get('clinic+date');
  // }
  setAge(d) {
    var b = moment(d);
    var a = new Date();

    a = moment(a);

    var years = a.diff(b, "year");
    b.add(years, "years");

    var months = a.diff(b, "months");
    b.add(months, "months");

    var days = a.diff(b, "days");

    if (years !== 0 && months == 0 && days == 0) {
      return years + " Tahun (Hari Lahir Pasien)";
    } else if (years == 0 && months == 0) {
      return days + " Hari";
    } else if (years == 0 && days == 0) {
      return months + " Bulan";
    } else if (years == 0) {
      return months + " Bulan " + days + " Hari";
    } else {
      return years + " Tahun " + months + " Bulan " + days + " Hari";
    }
  }
  buttonClick = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  //tindakan
  handleInputNameChangeTreatments = (idx) => (evt) => {
    const val = evt.split("-", 4);
    const newTreatments = this.state.treatments.map((tr, sidx) => {
      if (idx !== sidx) return tr;
      return {
        visit_id: this.props.data?.visit?.id,
        visit_inpatient_detail_id: "1",
        treatment_id: val[0],
        log: "0",
        treatment: { name: val[1] + ' ' + val[2] },
        price: val[2],
        payment_type: this.state.payment_type_id
      };
    });

    this.setState({ treatments: newTreatments });
    this.setState({ value: evt });
  };

  postTreatments = async (e) => {
    this.setState({ disable: true })
    const treatment = this.state.treatments;
    const res = await apiService.put("/registration/treatment/update", { treatment });
    if (res.code == 200) {
      // await apiService.post(`/fhir/satu_sehat/procedure/${this.state.visit_id}`, {})
      // this.changeDetilData(res.data);
      let get = await this.getBilingByPaymentId();
      toast({ status: 'success', text: 'berhasil menambah data' });
    } else {
      toast({ status: 'error', text: 'gagal data' });
    }
    this.setState({ disable: false })
  };
  handleRemoveInputTreatments = (idx) => (evt) => {
    const treatments = [...this.state.treatments];
    treatments[idx].log = 1;
    if (treatments[idx].treatment_id !== "") {
      this.setState({ treatments });
    } else {
      this.setState({
        [evt.target.name]: this.state.treatments.filter(
          (s, sidx) => idx !== sidx
        ),
      });
    }
  };
  retrieveDataAsynchronouslyTreatments = async (e) => {
    // console.log(e);
    let payment_type_id = this.state.payment_type_id;
    let res = await apiService.get(
      "management/treatments_price/read?payment_type=" +
      payment_type_id +
      "&keyword=" +
      e
    );
    if (res.code === 200) {
      this.setState({
        dataTreatments: res.data,
      });
    } else {
      // console.error("Cannot load data from remote source");
      this.setState({
        dataTreatments: [],
      });
    }
  };
  onChangeTreatments = (idx) => (evt) => {
    const newTreatments = this.state.treatments.map((tr, sidx) => {
      if (idx !== sidx) return tr;
      return {
        visit_id: this.props.data?.visit?.id,
        visit_inpatient_detail_id: "1",
        treatment_id: "",
        log: "0",
        treatment: { name: evt.target.value },
      };
    });

    this.setState({ treatments: newTreatments });

    /**
     * Handle the remote request with the current text !
     */
    const par = evt.target.value;
    // if (evt.target.value.length > 2) {
    // setTimeout(event => {
    // this.retrieveDataAsynchronouslyTreatments(par);
    // }, 300);
    // console.log("The Input Text has changed to ", par);
    // }
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      //search function
      this.retrieveDataAsynchronouslyTreatments(par);
    }, 500);
  };
  getItemValueTreatments(item) {
    // You can obviously only return the Label or the component you need to show
    // In this case we are going to show the value and the label that shows in the input
    // something like "1 - Microsoft"
    return `${item.treatment_id}-${item.treatment.name}-${item.price}-${item.id}`;
  }
  handleAddInput = (x) => (evt) => {
    this.setState({
      [evt.target.name]: x,
    });
  };
  //tindakan end

  //hitung total
  componentDidUpdate = (prevProps, prevState) => {
    if (prevState.data !== this.state.data) {
      console.log('berubah')
      let total = [];
      this.state.data?.biling?.map((a, ky) => {
        total.push(parseInt(a.price));
      })
      this.setState({ total: total });
    }
  }

  componentDidMount = () => {
    let total = [];
    this.props.data?.biling?.map((a, ky) => {
      total.push(parseInt(a.price));
    })
    this.setState({ total: total });
    this.fetchPaymentTypes();
  }

  deleteAlert = (e, data) => {
    let del = this.deleted;
    confirmedAlert(
      "Hapus Biling ?",
      `${data.name}`,
      function (confirmed) {
        if (confirmed) {
          del(data.id)
          console.log('deleted')
        } else {

        }
      }
    );
  }

  deleted = async (id) => {
    let res = await apiService.delete('registration/payment/delete_biling/' + id);
    if (res?.code == 200) {
      toast({ status: 'success', text: 'berhasil menghapus data' });
      let get = await this.getBilingByPaymentId();
    } else {
      toast({ status: 'error', text: 'gagal menghapus data' });
    }
  }

  getBilingByPaymentId = async () => {
    let res = await apiService.get('registration/payment/get_payment/' + this.state.data.num_of_ticket);
    if (res.code == 200) {
      this.setState(
        (prevState) => ({
          data: {
            // object that we want to update
            ...prevState.data, // keep all other key-value pairs
            biling: res.data, // update the value of specific key
          },
        }));

    } else {
      this.setState(
        (prevState) => ({
          data: {
            // object that we want to update
            ...prevState.data, // keep all other key-value pairs
            detail: [], // update the value of specific key
          },
        }));

    }
  }

  printKirit = async () => {
    let res = await BlobPrint(`/registration/print?visit_id=${this.state.data?.visit?.id}`);
  }

  render() {
    let patient = { patients: this.state.data.patient };
    let py = this.state.data;
    let dataDetail = this.state.data?.detail?.filter(a => a.created_at.substring(0, 10) == py.created_at?.substring(0, 10));

    let total = [];

    // let treatment = dataDetail.map((dat, key) => {
    //   return (
    //     <div key={key}>
    //       {dat.treatments?.length > 0
    //         ? dat.treatments.map((da, ky) => {
    //           if (da.log === false) {
    //             total.push(parseInt(da.treatment.price));
    //             let price = parseInt(da.treatment.price).toLocaleString();
    //             return (
    //               <div key={ky}>
    //                 <div key={ky} className="row col-md-12">
    //                   <div className="col-md-7">{da.treatment.name}</div>
    //                   <div
    //                     className="col-md-3"
    //                     style={{ textAlign: "right" }}
    //                   >
    //                     {price}
    //                   </div>
    //                 </div>
    //               </div>
    //             );
    //           }
    //         })
    //         : ""}
    //     </div>
    //   );
    // });
    let treatmentTr = this.state.data.biling?.map((dat, ky) => {
      return (
        <tr key={ky}>
          <td className="td">{dat.name}</td>
          <td className="td" style={{ textAlign: "right" }}>
            {dat.price}
          </td>
        </tr>
      );
    });

    return (
      <div>
        <div className="container-fluid my-3">
          <div className="row">
            <div className="col">
              <div className="row">
                <div className="col-xl-3 order-xl-1">
                  <DetailPatient patient={{ ...this.state.data.visit, ...patient, patient_id: patient.patients.id }} />

                  {/* <div className="card">
                    <Alergi patient={patient} />
                  </div> */}
                </div>

                <div className="col-xl-9 order-xl-2">
                  <div className="card">
                    <div className="card-header">Rincian Tagihan Pasien</div>
                    <div className="card-body">
                      <div className="card">
                        <div className="card-header">
                          <div className="row">
                            <div>
                              Tagihan
                            </div>
                            <div className="ml-2 mt--1">
                              <a
                                className="btn btn-sm btn-twitter btn-icon-only rounded-circle"
                                onClick={() => this.getBilingByPaymentId()}
                              >
                                <i
                                  className="fa fa-refresh"
                                  style={{ color: "white" }}
                                  aria-hidden="true"
                                ></i>
                              </a>
                            </div>

                          </div>
                        </div>
                        <div className="card-body">
                          {this.state.data?.biling?.map((a, ky) => {
                            total.push(parseInt(a.price));
                            return (
                              <div key={ky}>
                                <div key={ky} className="row col-md-12">
                                  <div className="col-md-7">{a.name}</div>
                                  <div
                                    className="col-md-3"
                                    style={{ textAlign: "right" }}
                                  >
                                    {a.price} - {`(${a.payment?.name})`}
                                  </div>
                                  <div>
                                    {/* {a.is_paid ? '' : */}
                                    <button className="btn btn-sm btn-danger" onClick={() => this.deleteAlert(ky, a)}>-</button>
                                    {/* } */}
                                  </div>
                                </div>
                              </div>
                            )
                          })}
                        </div>
                      </div>
                      <div className="card">
                        <div className="card-header">
                          <div className="row">
                            <div className="col-md-3">
                              Tambahan
                            </div>
                            <div className="col-md-8 row bg-gray">
                              <div className="text-white">Jenis Pembayaran</div>
                              <div>
                                <select
                                  className='form-control form-control-sm ml-3 bg-secondary'
                                  name='payment_type_id'
                                  id='payment_type_id'
                                  placeholder='pembayaran'
                                  value={this.state.payment_type_id}
                                  onChange={e => this.setState({ payment_type_id: e.target.value })}>
                                  {
                                    this.state.payment_types?.map((a, b) => (
                                      <option key={b} value={a.id}>{a.name}</option>
                                    ))
                                  }

                                </select>
                              </div>
                            </div>
                          </div>

                        </div>
                        <div className="card-body">
                          {/* <button className="btn btn-sm btn-primary">+</button>
                          <input className="form-control form-control-sm col-md-7"
                            type="text"
                            placeholder="uraian" />
                          <input className="form-control form-control-sm col-md-4"
                            type="text"
                            placeholder="jumlah" /> */}
                          {this.state.treatments.map((tr, idx) => {
                            if (tr.log < 1) {
                              return (
                                <div key={idx} className="form-group row">
                                  {
                                    <Autocomplete
                                      inputProps={{
                                        className: "form-control form-control-sm",
                                        placeholder: "ketikkan minimal 3 huruf tindakan",
                                      }}
                                      items={this.state.dataTreatments}
                                      getItemValue={this.getItemValueTreatments}
                                      renderItem={(item, highlighted) => (
                                        <div
                                          key={item.id}
                                          style={{
                                            backgroundColor: highlighted
                                              ? "#eee"
                                              : "transparent",
                                          }}
                                        >
                                          {item.id} - {item.treatment.name}-
                                          {item.price}
                                        </div>
                                      )}
                                      value={this.state.treatments[idx].treatment.name}
                                      onChange={this.onChangeTreatments(idx)}
                                      onSelect={this.handleInputNameChangeTreatments(idx)}
                                      menuStyle={{
                                        borderRadius: "3px",
                                        boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                                        background: "rgba(255, 255, 255, 0.9)",
                                        padding: "2px 0",
                                        fontSize: "90%",
                                        // position: "absolute",
                                        overflow: "scroll",
                                        // zIndex: "100",
                                        maxHeight: "100%", // TODO: don't cheat, let it flow to the bottom
                                      }}
                                      wrapperStyle={{
                                        maxWidth: "81.66667%",
                                        flex: "0 0 81.66667%",
                                        overflow: "scroll",
                                        maxHeight: '300px'
                                      }}
                                    />
                                  }

                                  <button
                                    className="btn btn-sm btn-danger"
                                    style={{ maxWidth: "10%", maxHeight: "32px" }}
                                    name="treatments"
                                    onClick={this.handleRemoveInputTreatments(idx)}
                                    type="button"
                                  >
                                    -
                                  </button>
                                </div>
                              );
                            }
                          })}
                          <button
                            type="button"
                            name="treatments"
                            style={{ marginLeft: "2%" }}
                            onClick={this.handleAddInput(
                              this.state.treatments.concat([
                                {
                                  visit_id: "",
                                  visit_inpatient_detail_id: "",
                                  treatment_id: "",
                                  log: "0",
                                  treatment: { name: "" },
                                  price: 0,
                                  payment_type: ''
                                },
                              ])
                            )}
                            className="btn btn-sm btn-primary"
                          >
                            Add
                          </button>
                        </div>
                        <div className="card-footer">
                          <button className="btn btn-sm btn-success" disabled={this.state.disable} onClick={() => this.postTreatments()}>simpan</button>

                        </div>
                      </div>
                      <div className="row col-md-12 bg-light">
                        <div className="col-md-7 "> Total</div>
                        {/* <div className="col-md-5"> {total.reduce((a, b) => a + b, 0)}</div> */}
                        <div
                          className="col-md-3"
                          style={{ textAlign: "right" }}
                        >
                          {Number(
                            total.reduce((a, b) => a + b, 0).toFixed(1)
                          ).toLocaleString()}
                        </div>
                      </div>
                    </div>
                    {/* cetak Kasir */}
                    <div
                      style={{ display: this.state.show ? true : "none" }}
                      ref={(el) => (this.componentRef = el)}
                    >
                      <div style={{ textAlign: "center" }}>
                        Bukti Pembayaran
                      </div>
                      <table className=" col-md-12">
                        <tbody>
                          <tr>
                            <td>No Rekam Medis</td>
                            <td>{this.state.data.visit.family_folder}</td>
                            <td>Jenis Kelamin</td>
                            <td>{patient.patients.sexs.name}</td>
                          </tr>
                          <tr>
                            <td>Nama</td>
                            <td>
                              {patient.patients.name}{" "}
                              {patient.patients.last_name}
                            </td>
                            <td>Jaminan</td>
                            <td>{patient.insurance_no}</td>
                          </tr>
                          <tr>
                            <td>Alamat</td>
                            <td>
                              {" "}
                              {patient.patients.address.toUpperCase()},{" "}
                              {patient.villages?.name},
                              {patient.villages?.district?.name}, <br></br>{" "}
                              {patient.villages?.district?.city?.name},{" "}
                              {patient.villages?.district?.city?.province?.name}
                            </td>
                            <td>Tgl Kunjungan</td>
                            <td>
                              <em>
                                {moment(
                                  this.state.data.visit.created_at
                                ).format("DD-MM-YYYY HH:mm:ss")}
                              </em>
                            </td>
                          </tr>
                          <tr>
                            <td>Tgl Lahir/Usia</td>
                            <td>
                              {" "}
                              {patient.patients.birth_place},{" "}
                              {moment(patient.patients.birth_date).format(
                                "DD-MM-YYYY"
                              )}
                              <br></br>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <br></br>
                      <table className="table col-md-12">
                        <tbody>
                          <tr style={{ backgroundColor: "brown" }}>
                            <td className="td" style={{ textAlign: "center" }}>
                              URAIAN
                            </td>
                            <td className="td" style={{ textAlign: "center" }}>
                              JUMLAH
                            </td>
                          </tr>

                          {treatmentTr}

                          <tr>
                            <td className="td">Total</td>
                            <td className="td" style={{ textAlign: "right" }}>
                              {" "}
                              {Number(
                                total.reduce((a, b) => a + b, 0).toFixed(1)
                              ).toLocaleString()}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    {/* cetak kasir end */}
                    <div className="card-footer">
                      <button
                        className="btn btn-danger"
                        onClick={this.props.close}
                      >
                        batal
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary"
                        onClick={() => this.setState({ modalShow: true })}
                      >
                        {" "}
                        Layani
                      </button>
                      {/* {this.state.data.paid ? (
                        <ReactToPrint
                          trigger={() => (
                            <a href="#">
                              <button className="btn btn-success">Cetak</button>
                            </a>
                          )}
                          onBeforeGetContent={() =>
                            this.handleBeforeGetContent()
                          }
                          onAfterPrint={() => this.setState({ show: false })}
                          pageStyle="@media print {
                          .table {
                              border: solid #000 !important;
                              border-width: 1px 0 0 1px !important;
                          }
                         .td {
                              border: solid #000 !important;
                              border-width: 0 1px 1px 0 !important;
                          }
                      }"
                          content={() => this.componentRef}
                        />
                      ) : (
                        ""
                      )} */}
                      {
                        // this.state.paid ? 
                        <button className="btn btn-primary" onClick={() => this.printKirit()}>print</button>
                        // :''
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ModalPelayanan
          data={this.state.data}
          total={this.state.total}
          show={this.state.modalShow}
          onHide={() => this.setState({ modalShow: false })}
          close={this.props.close}
        />
      </div>
    );
  }
}

export default PelayananPx;
